import { render, staticRenderFns } from "./krasList.vue?vue&type=template&id=2f45e188"
import script from "./krasList.vue?vue&type=script&lang=js"
export * from "./krasList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f45e188')) {
      api.createRecord('2f45e188', component.options)
    } else {
      api.reload('2f45e188', component.options)
    }
    module.hot.accept("./krasList.vue?vue&type=template&id=2f45e188", function () {
      api.rerender('2f45e188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kras/krasList.vue"
export default component.exports